/* Company Confidential, Copyright (c) 2017 CRF Box, Ltd. All Rights Reserved. */
export const HEADER_LOGO_LABEL = 'MANAGER';
export const APP_NAME = 'eConsent Manager';
export const ACCOUNT = 'Account';
export const HEADER_BRAND_NAME = 'Signant SmartSignals';
export const HELPDESK_LABEL = 'Help Desk';
export const STUDIES_PAGE = 'Studies';
export const USER_MANAGEMENT = 'User Management';
export const ORGANIZATION_DETAILS = 'Organization';
export const USERS = 'Users';
export const MULTIPLE_ROLES = 'Multiple Roles';
export const MULTIPLE_STUDIES = 'Multiple Studies';
export const VIEW_ORGANIZATION = 'View organization';
export const OWN_ORGANIZATION = 'Own organization';
export const ALL_ORGANIZATIONS = 'All organizations';
export const ACTIVE_STUDIES = 'Active Studies';
export const SPONSOR = 'Sponsor';
export const STUDY = 'Study';
export const STUDY_PROTOCOL = 'Study Protocol';
export const STUDY_NAME = 'Study Name';
export const PROTOCOL_NO = 'Protocol No.';
export const CONSENTS = 'Consents';
export const PARTICIPANT_ID = 'TrialConsent ID';
export const STATUS = 'Status';
export const OPTIONAL_DOCUMENTS = 'Optional documents';
export const ACTIONS = 'Actions';
export const GENERATE_PDF = 'Generate PDF';
export const ACTIONS_NEEDED = 'Actions needed';
export const NONE = 'None';
export const ALL_OPTIONAL_DOCUMENTS = 'All optional documents';
export const ALL_ACTIONS_NEEDED = 'All actions needed';
export const REVIEW_NEW_VERSION_OF_OPTIONAL_DOC = 'Review new version of optional document';
export const READY_FOR_Q_A = 'Ready for Q&A';
export const AWAITING_FOR_INVESTIGATOR_SIGNATURE = 'Awaiting for further signatures';
export const OPTIONAL_DOCUMENTS_ACTION_NEEDED = 'Action needed';
export const OPTIONAL_DOCUMENTS_NO_ACTION_NEEDED = 'No action needed';
export const CLINICAL_SITE = 'Clinical site';
export const DOCUMENT_NAME = 'Document Name';
export const TIMESTAMP = 'Date';
export const REPORTER = 'Reporter';
export const SECTION_ID = 'Section';
export const PARTICIPANT = 'Participant';
export const BODY = 'Body Text';
export const NO_DATA_AVAILABLE = 'There is no data.';
export const DETAILS = 'Details';
export const SPONSOR_NAME = 'Sponsor Name';
export const USER_ALLOCATION_ERROR_MSG = "User isn't allocated to any sponsors";
export const SELECT_SPONSOR_ERROR_MSG = 'Please select a sponsor first!';
export const SELECT_SPONSOR_MODAL_TITLE = 'Select Sponsor';
export const CHANGE_SPONSOR_MODAL_TITLE = 'Change Sponsor';
export const SIGN_OUT = 'Sign out';
export const LOG_OUT = 'Log out';
export const ACCESS_IS_DENIED_TITLE = 'Access is denied!';
export const ACCESS_IS_DENIED_SUBTITLE = 'You do not have permission to access this tool using this sponsor.';
export const SELECT_SPONSOR = 'Select sponsor';
export const EXPIRATION_DATE = 'Expiration Date';
export const EXPIRATION_DATE_UTC = 'Expiration Date (UTC+00:00)';
export const SIGNED_DOCUMENTS = 'Completed documents';
export const OBSOLETE_DOCUMENTS = 'Obsolete documents';
export const ASSIGNED_DOCUMENTS = 'Pending documents';
export const PARTICIPANT_DETAILS = 'Participant Details';
export const NO_SIGNED_DOCS = 'No fully signed documents';
export const NO_ASSIGNED_DOCS = 'No assigned documents';
export const NO_OBSOLETE_DOCS = 'No obsolete documents';
export const PDF_BROWSER_SUPPORT_WARNING =
  'The PDF cannot be previewed in this browser. Please download the PDF document to view it.';
export const PRINT_DOCUMENT_ERROR_MESSAGE =
  'An error has occurred generating the PDF document. Please try again, if the problem persists contact the Helpdesk.';
export const SUBJECT_ID = 'Subject ID';
export const CLOSE = 'Close';
export const MESSAGE = 'Message';
export const VIEW = 'View';
export const EDIT = 'Edit';
export const VIEW_AND_EDIT = 'View & edit';
export const ADD = 'Add';
export const SELECT_BTN = 'Select';
export const CANCEL_BTN = 'Cancel';
export const SUBMIT_BTN = 'Submit';
export const DELETE_BTN = 'Delete';
export const SAVE_BTN = 'Save';
export const BACK_BTN = 'Back';
export const EXPORT_BTN = 'Export';
export const NEXT_BTN = 'Next';
export const PREVIOUS_BTN = 'Previous';
export const SIGNATURE_DATE = 'Last signature date';
export const SIGNATURE_DATE_UTC = 'Last signature date (UTC+00:00)';
export const DOCUMENTS = 'Documents';
export const NOTES = 'Notes';
export const NOTE = 'Note';
export const ACTIVE = 'Active';
export const ABORTED = 'Declined to sign';
export const SIGNED = 'Fully signed';
export const SIGNED_ON_PAPER = 'Fully signed on paper';
export const PARTIALLY_SIGNED = 'Partially signed';
export const WITHDRAWN_CONSENT = 'Withdrawn consent';
export const SUPERSEDED = 'Superseded version';
export const WAITING_RECONSENTING = 'Needs to sign a new version';
export const WAITING_PAPER_SIGNING = 'Awaiting signature on paper';
export const REMOVED = 'Not applicable';
export const SUBJECT_INFORMATION = 'Subject Information';
export const DEPRECATED = 'Does not need to re-sign';
export const SUBJECT_STATUS_IN_STUDY = "Participant's status";
export const STUDY_SUBJECT_NUMBER = 'Study subject number';
export const SUBJECT_NUMBER_EMPTY = 'Not specified';
export const SUBJECT_PHI_INFORMATION = 'Subject PHI information';
export const SUBJECT_PHI_NAME = 'Subject name';
export const SUBJECT_PHI_EMAIL = 'Subject email';
export const SITE_NAME = 'Clinical site';
export const PARTICIPANT_NOTIFICATION_EMAIL = 'Participant Notification Email';
export const NAME = 'Name';
export const EMAIL_ADDRESS = 'Email Address';
export const NOTE_TYPE_GENERAL = 'General note about participant';
export const NOTE_TYPE_CONSENT_DOCUMENT = 'About a document';
export const ADD_NOTE_FOR_PARTICIPANT = 'Add note for participant with Id';
export const NOTE_TYPE = 'Type of note';
export const NOTE_DOCUMENT = 'Document';
export const NOTE_SECTION = 'Section';
export const NOTE_SUBJECT = 'Subject';
export const CONSENTING_JOURNAL = 'Journals';
export const JOURNAL = 'Journal';
export const UNAUTHORIZED_PDF = 'No rights to access the document. Please contact an administrator.';
export const NOT_FOUND_PDF = 'The document was not found. Please contact an administrator.';
export const SIGNED_DOCUMENT_PDF = 'Signed Document';
export const ROLE = 'Role';
export const ADD_NOTE = 'Add note';
export const HELPDESK_MODAL_TITLE = 'TrialConsent Helpdesk';
export const ERROR_LOADING_HELPDESK = 'Could not load the helpdesk numbers at the moment. Please try again later.';
export const HELPDESK_MESSAGE =
  'If you have any questions about how to use TrialConsent, call your local Helpdesk at any time:';
export const HELPDESK_PHONE_NUMBERS_LABEL = 'Your Helpdesk number(s):';
export const HELPDESK_COUNTRIES_PLACEHOLDER = 'Select country';
export const PEOPLE_DETAILS_PEOPLE = 'People';
export const PEOPLE_DETAILS_EMAIL = 'Email';
export const ROLE_MGMT_ONGOING_STUDIES = 'Ongoing studies at ';
export const ROLE_MGMT_ADD_ROLE = 'Add role';
export const ROLE_MGMT_SELECT_STUDY = 'Select study';
export const ROLE_MGMT_SELECT_ROLE = 'Select role';
export const ROLE_MGMT_SELECT_ORGANIZATION = 'Select organization';
export const ROLE_MGMT_NO_STUDIES = 'No studies for assignment';
export const ROLE_MGMT_ADD_VALIDATION_STUDY_ORG = 'Please select an organisation and a study.';
export const ROLE_MGMT_ADD_VALIDATION_REASON = 'Please provide a reason.';
export const ROLE_MGMT_DELETE_VALIDATION_REASON = 'Please provide a reason.';
export const ROLE_MGMT_ADD_VALIDATION_ROLE = 'Please update the role.';
export const ROLE_MGMT_ADD_VALIDATION_NO_STUDIES = 'There are no studies for assignments.';
export const ROLE_MGMT_LOG_REASON = 'Role delegation reason ...';
export const DELETE_ASSIGNMENT_TITLE = 'Confirm removal from this study';
export const DELETE_ASSIGNMENT_MESSAGE = 'Please confirm that you are removing this person role from the study ';
export const CREATE_ASSIGNMENT_TITLE = 'Assign role';
export const DEFAULT_SELECT_OPTION = 'Select your option';
export const VERSION = 'version';
export const TIME = 'Time';
export const EVENT = 'Event';
export const ACTIVITY = 'Activity';
export const KNOWLEDGE_CHECK_ANSWER_CORRECT = 'Answers question correctly';
export const KNOWLEDGE_CHECK_ANSWER_INCORRECT = 'Answers question incorrectly';
export const FLAG = 'Flags item';
export const UNFLAG = 'Unflags item';
export const SIGNATURE_AFFIRMATION = 'Checks affirmation';
export const IDENTITY_CHECKED = 'Checks identity';
export const CHECKS_CHECKBOX_ANSWER = 'Checks checkbox';
export const UNCHECKS_CHECKBOX_ANSWER = 'Unchecks checkbox';
export const SELECTS_RADIO_BUTTON = 'Checks radio';
export const DESELECTS_RADIO_BUTTON = 'Changes radio';
export const STATUS_UPDATE = 'Participant status changed';
export const CONSENTING_STATUS_UPDATE = 'Consenting status changed';
export const CHANGE_ANSWERS_REQUESTED = 'Change answer(s) request';
export const CHANGE_ANSWERS_DISCUSSED = 'Investigator approved discussion';
export const CHANGE_ANSWERS_ACCEPTED = 'Change answer(s) accepted';
export const CHANGE_ANSWERS_CANCELLED = 'Change answer(s) cancelled';
export const PARTICIPANT_STATUS_UPDATE = 'Participant status changed';
export const PARTICIPANT_CREATED = 'Participant created';
export const PARTICIPANT_LATEST_STATUS_CHANGE = 'Latest status change';
export const PARTICIPANT_SITE = 'Site';
export const CONSENTING_CREATED = 'Consent created';
export const ABORT_DATA = 'Aborts consent';
export const PDF_MANUALLY_UPLOADED = 'PDF manually uploaded';
export const PDF_MANUALLY_REMOVED = 'PDF manually removed';
export const ADDENDUM_MANUALLY_UPLOADED = 'Addendum manually uploaded';
export const ADDENDUM_MANUALLY_REMOVED = 'Addendum manually removed';
export const DOCUMENT = 'Document: ';
export const VERSION_NO = 'Version number';
export const SESSION_EXPIRED = 'Session expired. Please login again.';
export const DOCUMENTS_PAGE_TITLE = '';
export const ADD_NOTE_PAGE_TITLE = '';
export const STUDY_DETAILS_TITLE = 'Study details';
export const PARTICIPANTS_TAB = 'Participants';
export const DELEGATION_LOG_TAB = 'Study personnel';
export const NOT_PARTICIPATING = 'Not Participating';
export const STUDIES_PAGE_TITLE = 'Studies';
export const DOCUMENTS_DETAILS_TEXT =
  'This page lists the documents which this participant has signed or would need to sign in order to take part in the study. \nStaff at clinical sites may add notes about the participant’s experience, and if necessary change the participant’s status in respect of a document.';
export const ADD_NOTE_DETAILS_TEXT =
  'You may write a note about a specific document. Your note will be treated as protected health information.';
export const PARTICIPANTS_PAGE_DETAILS_TEXT =
  'This page lists all the participants who are now, or have previously been involved in  the study at your organization. Click ‘View’ for information about each participant’s experience.';
export const STUDIES_DETAILS_TEXT =
  'Welcome to TrialConsent Manager. This page lists all of the Studies with which your organization is involved. Tap ‘view’ for details of study documents and to monitor the consenting process.';
export const NOTES_PANEL_DETAILS_TEXT =
  'Authorized study team members may make a note about a specific document of the participant. All the notes related to participant’s consenting experience are available for visualization and download under this tab.';
export const NOTES_PANEL_TITLE = '';
export const AMEND_DOCUMENT_STATUS =
  'If you believe this status to be incorrect, you can amend the status in respect of a specific document:';
export const GO_TO_DOCUMENTS_LIST = 'Go to documents list';
export const TERMINATE_PARTICIPANT_STUDY = 'Alternatively, you can end this person’s participation in the study:';
export const AMEND_PARTICIPANT_STATUS = "Go to 'amend status' page";
export const CHANGE_STATUS_REASON = 'Reason for status change ';
export const CHANGE_PARTICIPANT_STATUS_REASON = 'Reason for status change';
export const CHANGE_STATUS_TITLE = 'Change Status';
export const PARTICIPANT_STATUS = 'Participant status';
export const ACTIVE_IN_STUDY = 'Active in study';
export const SELECT_CHOOSE_ONE = 'Select one...';
export const REACTIVATE_PARTICIPANT_IN_STUDY_DESCRIPTION =
  'If this status is incorrect, you can reactivate the participant in the study:';
export const REACTIVATE_PARTICIPANT_IN_STUDY = 'Reactivate participant';
export const STUDY_PARTICIPANT = 'Study participant';
export const NO_PARTICIPANTS_DATA = 'No participants found.';
export const FILTERS_APPLIED = 'Filters applied';
export const FILTERS_APPLIED_LIST_REFRESHED = 'The list was refreshed';
export const SEARCH_BY_USERNAME_AND_SSN = 'Search by Username or SSN';
export const PARTICIPANTS_PAGE_ERROR = 'There was an error. Please refresh the page.';
export const ACTIVE_DETAILS = '';
export const ABORTED_DETAILS = 'Participant decided not to sign the document';
export const WAITING_RECONSENTING_DETAILS = 'Document has been re-issued to be signed again';
export const WAITING_PAPER_SIGNING_DETAILS = 'Participant decided to sign on paper';
export const SIGNED_ON_PAPER_DETAILS = 'Participant signed a paper version of the document';
export const WITHDRAWN_CONSENT_DETAILS = '';
export const DEPRECATED_DETAILS = 'Participant has been wrongly marked as “needs reconsenting"';
export const HTTP_STATUS_MESSAGES = {
  400: 'Bad Request. Your browser sent a request our server cannot understand',
  404: 'The requested content was not found',
  401: 'You are not authorized to view the requested content',
  403: 'You are not authorized to view the requested content',
  500: 'Internal Server Error'
};
export const REASON_DELETE = 'Reason for deletion';
export const REASON_ADD = 'Reason for adding';
export const DELETE_PDF_TITLE = 'Delete PDF';
export const ADD_NEW_NOTE = 'Add notes';
export const VIEW_CONSENTING_JOURNAL = 'View journal';
export const VIEW_SIGNED_PDF = 'View fully signed PDF';
export const DELETE_SIGNED_PDF = 'Delete fully signed PDF';
export const VIEW_PDF = 'View PDF';
export const CHANGE_DOCUMENT_STATUS = 'Change document status';
export const CHANGE_DOCUMENT_STATUS_COMPLETE_SOP_OPT_INOUT = 'Complete consent form';
export const CHANGE_ANSWERS_OPTIN_OPTOUT = 'Complete consent form';
export const SELECT_VALUE_ALL = 'All';
export const SELECT_VALUE_ALL_STATUSES = 'All statuses';
export const VIEW_JOURNAL_PDF = 'View journal PDF';
export const DOWNLOAD = 'Download';
export const CAN_VIEW_PHI = 'See PHI';
export const CAN_OBTAIN_PHI = 'Obtain IC';
export const ALL_SITES = 'All sites';
export const CHANGE_SUBJECT_NUMBER_REASON = 'Notes about the study subject number:';
export const CHANGE_SUBJECT_NUMBER_REASON_DETAILS =
  'You may add explanatory notes if, for example, you are amending' +
  ' the Subject number. Notes are recorded into the Participant’s journal.';
export const PARTICIPANT_INFORMATION = 'Study subject number changed';
export const PARTICIPANT_PRIVACY_POLICY_STATUS = 'Participant accepted the privacy policy';
export const NOTIFICATION_EMAIL_UPDATED = 'Notification email updated';
export const STUDY_PROTOCOL_NO = 'Study Protocol No.';
export const PARTICIPANT_USERNAME = 'Participant username';
export const THERAPEUTIC_AREA = 'Therapeutic Area';
export const STUDY_PHASE = 'Study Phase';
export const PROTOCOL_NAME = 'Protocol Name';
export const SWITCH_TO_UAT = 'Switch to test copy';
export const MATERIAL_CHECK_ICON = 'check';
export const MATERIAL_CLOSE_ICON = 'close';
export const FIRST_NAME = 'First name';
export const LAST_NAME = 'Last name';
export const GENDER = 'Participant gender';
export const GENDER_NAME = {
  1: 'Male',
  2: 'Female'
};
export const BIRTHDATE = 'Participant date of birth';
export const ADDRESS_CITY = 'City';
export const ADDRESS_POSTAL_CODE = 'Postal Code';
export const ADDRESS_STREET = 'Street Address';
export const CHANGE_PARTICIPANT_GENDER_TITLE = 'Change participant gender';
export const NEW_PARTICIPANT_GENDER_LABEL = 'New participant gender';
export const CHANGE_PARTICIPANT_GENDER_REASON = 'Reason for change';
export const PARTICIPANT_GENDER_UPDATED = 'Participant gender updated';
export const CHANGE_PARTICIPANT_BIRTHDATE_TITLE = 'Change participant date of birth';
export const SELECT_PARTICIPANT_BIRTHDATE = 'Select birth date:';
export const CHANGE_PARTICIPANT_BIRTHDATE_REASON = 'Reason for change';
export const PARTICIPANT_BIRTHDATE_UPDATED = 'Participant date of birth updated';
export const PARTICIPANT_BIRTHDATE_UPDATE_ERROR = 'Date of birth cannot be in the future';
export const PARTICIPANT_ADDRESS_UPDATED = 'Participant address updated';
export const CHANGE_PARTICIPANT_ADDRESS_TITLE = 'Change participant address';
export const CHANGE_PARTICIPANT_ADDRESS_REASON = 'Reason for change';
export const CHANGE_ADDRESS_CITY = 'City';
export const CHANGE_ADDRESS_POSTAL_CODE = 'Postal Code';
export const CHANGE_ADDRESS_STREET = 'Street Address';
export const CHANGE_PARTICIPANT_STATUS_TITLE = 'Change participant status';
export const CHANGE_PARTICIPANT_JOURNEY_TITLE = 'Change study subject number';
export const RAPORTS_HEADER_SITE = 'SITE';
export const RAPORTS_HEADER_ANSWERS = 'Answers to opt-in opt-out questions';
export const RAPORTS_NO_DATA = 'No reports available';
export const RAPORTS_FOOTER = 'Show all reports';
export const RAPORTS_DOWNLOAD = 'Download.csv';
export const MENU_DOWNLOAD = 'Download';
export const MENU_ACCESS_RIGHTS_LABEL = 'Access rights history';
export const DOWNLOADS = 'Downloads';
export const RAPORTS_ALL_SITES = 'All sites';
export const REPORTS_MODAL_TITLE = 'Exports Answers to opt-in opt-out questions';
export const PARTICIPANT_ARCHIVE_TITLE = 'Export Participant Data Archive';
export const USER = 'User';
export const PARTICIPANT_FLAGGED = {
  image: 'flagged this image:',
  video: 'flagged this video:',
  html: 'flagged this paragraph:'
};
export const PARTICIPANT_UNFLAGGED = {
  image: 'unflagged this image:',
  video: 'unflagged this video:',
  html: 'unflagged this paragraph:'
};
export const FLAG_ANSWERED = {
  image: 'confirms questions about this image answered:',
  video: 'confirms questions about this video answered:',
  html: 'confirms questions about this paragraph answered:'
};
export const FLAGGED_PARAGRAPH = 'Flagged paragraph';
export const FLAGGED_IMAGE = 'Flagged image';
export const FLAGGED_VIDEO = 'Flagged video';
export const VIEW_PARAGRAPH = 'View full paragraph';
export const VIEW_IMAGE = 'View image';
export const VIEW_VIDEO = 'View video';
export const UPLOAD_PDF = 'Upload a scanned copy';
export const TOO_LARGE_ERROR = 'The file is too large! Please upload a file smaller than 8MB.';
export const WRONG_TYPE_ERROR = 'The file type is not supported! Please upload a *.pdf file.';

export const BIOSAMPLE_ADDED = 'Item ID added';
export const BIOSAMPLE_UPDATED = 'Item ID updated';
export const BIOSAMPLE_REMOVED = 'Item ID deleted';

export const FILTER_BY_SITE = 'Filter sites: ';

export const DL_COLUMN_USER = 'User';
export const DL_COLUMN_ASSIGNED = 'Assigned';
export const DL_COLUMN_ORGANIZATION = 'Organisation';
export const DL_COLUMN_SITE = 'Access to site';
export const DL_COLUMN_COUNTRY_ACCESS = 'Access to country';
export const DL_COLUMN_COUNTRY = 'Country';
export const DL_COLUMN_COLLAPSE = 'Collapse All';
export const DL_COLUMN_EXPAND = 'Expand All';
export const NO_DELEGATION_LOGS = 'No delegation logs found.';
export const IRB_TYPE = 'IRB';
export const NA_ORG_NAME = 'N/A';
export const ONLY_DOCUMENTS_ASSIGNED = 'Only to documents assigned to user’s organization';

export const SHOW_MORE = 'Show more';
export const SHOW_LESS = 'Show less';

export const COUNTRY_SELECTOR_LABELS = {
  ALL: 'All countries',
  NONE: 'No countries selected',
  NAME: 'Countries',
  EMPTY: 'No countries match'
};
export const NOT_AVAILABLE = 'N/A';

export const DATE_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const ADD_NEW_PARTICIPANT_DOCUMENT_TITLE = 'Select document';
export const ADD_DOCUMENT = 'Add document';
export const NO_CONTENT_FOUND = 'No content found';
export const NO_RESULTS_FOUND = 'No results found';
export const ADD_COMMENT = 'Add your comment';
export const SEARCH_DOCUMENT = 'Search document';

export const SELECT_SIGNATURES_LABEL = 'Select signature(s) for the study document';
export const SIGNATURE_PARTICIPANT = 'Participant';
export const SIGNATURE_LAR = 'LAR (Legally Authorized Representative)';
export const SIGNATURE_PARENT_GUARDIAN = 'Parent(s)/guardian(s)';
export const ONE_PARENT_GUARDIAN = 'One parent/guardian is present';
export const TWO_PARENTS_GUARDIANS = 'Two parents/guardians are present';
export const SIGNATURE_WITNESS = 'Independent Witness';
export const CONFIRM_REPRESENTATION_CHANGE_WARNING = 'The consenting type will be different from the previous document';
export const CONFIRM_REPRESENTATION_CHANGE_ACK = 'I confirm this representation change';

export const REMOVE_DOCUMENT_FROM_LIST = 'Remove latest version';
export const REMOVE_ENTIRE_DOCUMENT_FROM_LIST = 'Remove document';

export const VIEW_ADDENDUM_PDF = 'View fully signed PDF';
export const DELETE_ADDENDUM = 'Delete fully signed PDF';
export const DELETE_ADDENDUM_MODAL_TITLE = 'Delete PDF';
export const ADDENDUM_ID = 'Addendum id';
export const DELETE_ADDENDUM_REASON = 'Reason for deletion';
export const DELETE_ADDENDUM_ERROR_MESSAGE = 'There was a problem, please try again.';
export const ADDENDUM = 'Addendum';

export const DELEGATION_LOG_ALL_COUNTRIES = 'All regions in the study';
export const DELEGATION_LOG_ALL_SITES = 'All sites in the study';
export const LAST_CHANGED = 'Last changed';
export const MANUAL_MESSAGE = (name, operation, user) => `${name} was manually ${operation} by ${user}.`;
export const DOCUMENT_REMOVED_MESSAGE = (name, user) => `Document ${name} was manually removed by ${user}.`;
export const JOURNAL_REASON = (reason) => `${reason ? 'Reason of change: ' + reason : ''}`;
export const MANUAL_VERSION_OPERATION = { VERSION_ADDED: 'added', VERSION_REMOVED: 'removed' };
export const VERSION_ADDED = 'Document version added manually';
export const VERSION_REMOVED = 'Document version removed manually';
export const DOCUMENT_REMOVED = 'Document removed manually';

export const PAGINATION_HEADS_THRESHOLD = 5;
export const EMPTY_COUNTRY = '';

export const MANDATORY_FOR_ALL_LABEL = 'Mandatory for ALL participants to read and sign';
export const MANDATORY_FOR_SELECTED_LABEL = 'Mandatory for SELECTED participants to read and sign';
export const OPTIONAL_FOR_ALL_LABEL = 'Optional for ALL participants to read and sign';
export const OPTIONAL_FOR_SELECTED_LABEL = 'Optional for SELECTED participants to read and sign';

export const PARTICIPANT_HAS_NEW_VERSIONS_TO_SIGN_TITLE =
  'There are new document versions available for this participant!';
export const PARTICIPANT_HAS_NEW_VERSIONS_TO_SIGN_MESSAGE =
  "Note that there are new versions available for this participant's documents. You can use 'Add document' button to manually add the new document versions to the participant.";
export const PARTICIPANT_CONTINUE_WITH_EXISTING_DOCUMENTS = 'Continue with existing documents';
export const I_NEED_TO_ADD_DOCUMENTS_TO_PARTICIPANT = 'I need to add new documents';

export const SAVE_ADDITIONAL_ROLES = 'SAVE_ADDITIONAL_ROLES';
export const SPONSOR_MONITOR = 'SPONSOR_MONITOR';
export const SITE_USER = 'SITE_USER';

export const JOURNAL_CONSTANTS = {
  SIGNED: 'Signed'
};

export const PARTICIPANT_EMAIL = {
  PROVIDED: 'Provided (hidden)',
  NOT_PROVIDED: 'Not provided'
};

export const CHANGE_PARTICIPANT_EMAIL_TITLE = 'Change notification participant email';
export const NEW_PARTICIPANT_EMAIL_LABEL = 'New email address';
export const NEW_PARTICIPANT_EMAIL_REASON = 'Reason for change';
export const CLEAR = 'Clear';

// Responses tab
export const RESPONSES = 'Responses';
export const RESPONSES_SIGNED_DOCUMENTS = 'Signed Documents';
export const RESPONSES_EMPTY_SIGNED_DOCUMENTS = 'No Signed Documents';
export const RESPONSES_DECLINED_DOCUMENTS = 'Declined Documents';
export const RESPONSES_EMPTY_DECLINED_DOCUMENTS = 'No Declined Documents';
export const RESPONSES_QUESTION = 'Question';
export const RESPONSES_RESPONSE = 'Response';
export const RESPONSES_ITEM_ID = 'Item ID';
export const RESPONSES_NOT_SPECIFIED = 'Not Specified';
export const RESPONSES_BIOSAMPLE_SAVING = 'Saving...';
export const RESPONSES_DOCUMENT = 'Document';
export const RESPONSES_VERSION = 'Version';
export const RESPONSES_SIGNED_DATE = 'Signed Date';
export const RESPONSES_ABORTED_DATE = 'Aborted date';
export const RESPONSES_DATA_FETCH_ERROR = 'Error fetching responses data.';
export const RESPONSES_REMOVE_BIOSAMPLE_CONFIRM = 'Are you sure you want to delete?';
export const RESPONSES_UPDATE_BIOSAMPLE_CONFIRM = 'Change Item ID';
export const RESPONSES_CURRENT_BIOSAMPLE_CODE = 'Current Item ID';
export const RESPONSES_ADD_REASON = 'Add reason';
export const RESPONSES_REASON_FOR_REMOVE = 'Reason for deletion';
export const RESPONSES_NEW_BIOSAMPLE_CODE = 'New Item ID';
export const RESPONSES_ADD_NEW_BISAMPLE_CODE = 'Add new id';
export const RESPONSES_REASON_FOR_UPDATE = 'Reason for change';
export const RESPONSES_INFO_TOOLTIP_TEXT =
  'Item ID is a unique identification number that is associated with each participant sample or related item. Note that each sample or related item must be labeled with its own unique identifier.';
export const RESPONSES_ADD_ITEM = 'Add Item ID';
export const RESPONSES_REMOVE_ITEM = 'Delete Item ID';
export const RESPONSES_SAVE_ERROR = 'Unable to save, please try again.';
export const RESPONSES_UNIUE_ID_ERROR = 'Please enter a unique Item ID.';
export const RESPONSES_CHANGING_VERSION = 'Changing version...';
export const RESPONSES_CHANGE_VERSION_ERROR = 'Unable to change version, please try again.';
export const REPORTS = 'Reports';
export const FULL_SCREEN = 'Full screen';
export const REPORTS_SHEETS_TITLE = 'Select a report type';
export const REPORT_VISUALISATION = 'Report visualization';
export const EXPORT_DATA = 'Export Data';
export const ANSWERS_TO_OPT_IN = 'Answers to opt-in opt-out questions';
export const ACCESS_RIGHTS_HISTORY = 'Access rights history';
export const ACTIVE_STUDY_PERSONEL = 'Active study personnel';
export const EXPORT = 'Export';
export const SELECT_REPORTS = 'Select report';
export const PARTICIPANT_ARCHIVE = 'Participant data archive';
export const NEXT = 'Next';
export const SELECT_TO_EXPORT = 'Select Data to export';
export const SIGNED_CONSENTINGS = 'Signed PDF consent documents';
export const CONSENT_JOURNAL = 'Consent and participant journal';
export const CONFIRM_EXPORT_MODAL_TITLE = 'Preparing Participant Data Archive.';
export const CONFIRM_EXPORT_MODAL_BODY =
  'Please do not close your browser window until the data is gathered. A notification email including the access code for unpacking the archive will be send to your email address after the archive is generated. Click OK to continue using TrialConsent Manager.';
export const OK = 'OK';
export const CANCEL_EXPORT = 'Cancel Export';
export const CANCEL_DOWNLOAD = 'Cancel Download';
export const RETRY = 'Retry';
export const EXPORT_COMPLETED = 'Export complete:';
export const EXPORT_FAILED = 'Export failed. Would you like to retry or cancel?';
export const DATA_ARCHIVING =
  'There is participant data that needs archiving. \n Site User(s) having access rights to PHI data can download the archive.';
export const DATA_EXPORTED = 'Participant data has been exported.';
export const DOCUMENT_CHANGE_STATUS_SOP_OPTIN_OPTOUT_STEP_DESCRIPTION =
  'This form is collecting opt-in/opt-out data, please select or modify participant selections as per signed document.';
export const DOCUMENT_CHANGE_STATUS_SOP_OPTIN_OPTOUT_LABEL = 'Participant selections';
export const DOCUMENT_CHANGE_STATUS_SOP_OPTIN_OPTOUT_NO_VALUES = 'No opt-in/opt-out available';
export const CHANGE_ANSWERS = 'Change Answers';
export const FINISH_BTN = 'Finish';
export const CHANGE_ANSWERS_ADDENDUM_STEP_DESCRIPTION =
  'Please select if you would like the system to generate an addendum for the new modified answers or if you would like to upload a scanned copy of the original signed on paper addendum.';
export const CHANGE_ANSWERS_DATE_REASON_DESCRIPTION =
  'Before proceeding, please make sure you have access to the signed consent form.';
export const CHANGE_ANSWERS_DATE = 'Signature date';
export const CHANGE_ANSWERS_REASON = 'Reason for change';
export const CHANGE_ANSWERS_ADDENDUM_RADIO_GENERATE = 'Generate addendum';
export const CHANGE_ANSWERS_ADDENDUM_RADIO_UPLOAD = 'Upload a scanned copy of the addendum';

export const SIGN_ON_PAPER_CHANGE_ANSWERS = 'Changes answers';

export const SELECT_PDF_DOC = 'Upload file (*.pdf)';
export const REPLACE_PDF_DOC = 'Replace PDF document';
export const SELECT_FILE = 'Select file';
export const CLAIM_YOUR_ACCOUNT = 'ID Portal Registration';
